(function () {
  'use strict';
  document.querySelectorAll('[data-car]').forEach(function (car) {
    var track = car.querySelector('.track'), ghost = track.querySelector('.ghost');
    var label = car.querySelector('[data-car-page]'), words = label.textContent.split(/\d+/);
    var total = Number(car.getAttribute('data-total')), queue = [], promise, observer;
    var rtl = getComputedStyle(track).direction === 'rtl' || document.documentElement.dir === 'rtl';
    function paint() {
      var page = Math.min(Math.ceil(total / 6), Math.floor(Math.abs(track.scrollLeft) / track.clientWidth) + 1);
      label.textContent = words[0] + page + words[1] + Math.ceil(total / 6) + (words[2] || '');
      label.setAttribute('aria-label', label.textContent);
    }
    function insert() {
      queue.splice(0, 12).forEach(function (card) { track.insertBefore(card, ghost); });
      var loaded = track.querySelectorAll('a.book').length;
      car.setAttribute('data-loaded', loaded);
      if (loaded >= total) {
        if (observer) observer.disconnect();
        ghost.remove();
        ghost = null;
      } else if (observer && queue.length) {
        observer.unobserve(ghost);
        requestAnimationFrame(function () { if (ghost) observer.observe(ghost); });
      }
    }
    function load() {
      if (!ghost) return;
      if (queue.length) { insert(); return; }
      if (promise) return;
      var section = car.getAttribute('data-more');
      if (!section) return;
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      promise = fetch(root + '?sections=' + encodeURIComponent(section), {credentials: 'same-origin'})
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (data) {
          var box = document.createElement('div');
          box.innerHTML = data[section] || '';
          var list = box.querySelector('[data-more-list]');
          if (!list) throw new Error();
          queue = Array.from(list.querySelectorAll('a.book'));
          insert();
        }).catch(function () { /* The ordinary shelf link remains available. */ });
    }
    function move(n) {
      track.scrollBy({left: n * track.clientWidth * (rtl ? -1 : 1), behavior: 'smooth'});
    }
    car.querySelector('[data-car-prev]').addEventListener('click', function () { move(-1); });
    car.querySelector('[data-car-next]').addEventListener('click', function () { move(1); });
    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
    });
    track.addEventListener('scroll', paint, {passive: true});
    window.addEventListener('resize', paint);
    if (ghost && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) load();
      }, {root: track, rootMargin: '0px 100%'});
      observer.observe(ghost);
    }
    paint();
  });
}());
